import { Spin } from "antd";
function LoadingComponentAntD({ content }) {
  return (
    <>
      <section className="loader-wrapper">
        <Spin tip={content} size="large">
          {content}
        </Spin>
      </section>
    </>
  );
}

export default LoadingComponentAntD;
